import StyledLogo from "../Utils/Logo.styled";
import { Icon, SearchContainer, IconContainer } from "./Search.styled";
import logo from "../../assets/images/YouTube.svg";
import { motion } from "framer-motion";
import { ReactComponent as Logo } from "../../assets/images/search.svg";
import Stack from "../Utils/Stack.styled";
import Input from "../Input/Input";
import { useForm } from "react-hook-form";
import useKeyPress from "../../helper/useKeyPress";
import CONSTANT from "../../constants/constant";
import useNavigateParams from "../../helper/navigateHelper";

const Search = ({ onSearch, variant, hideSearch = false }) => {
  const navigate = useNavigateParams();
  const { handleSubmit, register, getValues } = useForm();

  useKeyPress((key) => {
    const currentValue = getValues("search");
    if (key === CONSTANT.KEY.ENTER && currentValue) onSearch(currentValue);
  });

  const onHandleSubmit = ({ search }) => {
    if (search) onSearch(search);
  };
  return (
    <SearchContainer variant={variant}>
      <Stack
        direction={variant === CONSTANT.VARIANT.SMALL ? "row" : "column"}
        gap="24"
        alignItems={
          variant === CONSTANT.VARIANT.SMALL ? "center" : "flex-start"
        }
      >
        <StyledLogo
          as={motion.img}
          key="search"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 1,
          }}
          src={logo}
          height="fit-content"
          width={variant === CONSTANT.VARIANT.SMALL ? "120px" : "150px"}
          variant={variant}
          onClick={() =>
            variant === CONSTANT.VARIANT.SMALL
              ? navigate("results", { q: "rose" })
              : {}
          }
        />
        <Stack
          as={motion.div}
          animate={{ opacity: hideSearch ? 0 : 1 }}
          transition={{
            duration: 0.6,
          }}
          style={{
            position: "relative",
            height: variant === CONSTANT.VARIANT.SMALL ? "40px" : "50px",
          }}
          justifyContent={
            variant === CONSTANT.VARIANT.SMALL ? "start" : "center"
          }
          gap="0"
        >
          <Input
            variant={variant}
            placeholder="Search..."
            id="search"
            {...register("search")}
          />
          <IconContainer
            onClick={handleSubmit(onHandleSubmit)}
            variant={variant}
          >
            <Icon variant={variant}>
              <Logo
                fill="red"
                width={variant === CONSTANT.VARIANT.SMALL ? "22px" : "28px"}
                height={variant === CONSTANT.VARIANT.SMALL ? "22px" : "28px"}
              />
            </Icon>
          </IconContainer>
        </Stack>
      </Stack>
    </SearchContainer>
  );
};

export default Search;
